<script setup lang="ts">
import { useDisplay } from 'vuetify'

import { useEditorStore } from '@/stores/Editor'

import EditorFrame from '@/components/editor/EditorFrame.vue'
import EditorDeviceSelect from '@/components/editor/EditorDeviceSelect.vue'

const { width: screenSize } = useDisplay()
const store = useEditorStore()
</script>

<template>
  <main class="editor-content">
    <div class="editor-content-inner">
      <EditorDeviceSelect v-if="!store.previewMode && screenSize > 960" />
      <EditorFrame />
    </div>
  </main>
</template>

<style lang="scss" scoped>
.editor-content {
  padding: 12px;
  background-color: #eaeaea;
  grid-area: content;

  @include media('md-and-up') {
    padding: 25px 12px 12px;
  }

  :deep(.editor-device-select) {
    @include media('md-and-up') {
      margin-bottom: 32px;
    }
  }
}

.editor-content-inner {
  height: calc(100% - 20px);
}
</style>
